import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    description: 'Avisos e Notificações',
    path: '/administracao/avisosnotificacoes',
    name: 'avisosnotificacoes',
    component: () => import('@/views/administracao/avisosnotificacoes/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.CADASTRO_AVISOSENOTIFICACOES_MENU_301400150],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Avisos e Notificações',
    path: '/administracao/avisosnotificacoes/cadastro/:id?',
    parent: 'avisosnotificacoes',
    name: 'avisosnotificacoes_create',
    component: () =>
      import('@/views/administracao/avisosnotificacoes/components/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.CADASTRO_AVISOSENOTIFICACOES_MENU_301400150],
    },
    goesToMenu: true,
  },
];
